import { View, Text } from "@react-pdf/renderer";
import styles from "./styles";
import FaNum from "./FaNum";

export default function SellerCard() {
  return (
    <View style={styles.sellerCard}>
      <Text style={styles.cardTitle}>فروشنده:  کافه دارو </Text>

      <Text style={styles.cardText}>
        <FaNum>تهران، شاهین شمالی، روبروی مجموعه خرمشاد، پلاک ۲۷</FaNum>
      </Text>

      <Text style={styles.cardText}>
        <FaNum>  info@cafedaru.shop  :پست الکترونیک</FaNum>
      </Text>

      <Text style={styles.cardText}>
        <FaNum>تلفن: 02147586 و 02191018326 و 09011000103</FaNum>
      </Text>
    </View>
  );
}
